import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../styles/common/progLangList.module.css'
import progLanguages from '../../constants/common/ProgLanguages'
import { toggleProgLangList } from '../../actions/commonActions'


export class ProgLangListHeader extends Component {
    render() {
        const { listHeaderOpen, listHeader, title } = styles;
        const { isOpen, toggleProgLangList } = this.props;

        return (
            <div className={isOpen ? listHeaderOpen : listHeader} onClick={toggleProgLangList}>
                <span className={title}>{progLanguages[this.props.selection].name}</span>
                <i style={{ fontSize: '1.2rem', color: '#343535'}} className={"material-icons"}>{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { selection, isOpen } = state.common.progLangList;
    return { selection, isOpen };
}

export default connect(mapStateToProps, {toggleProgLangList})(ProgLangListHeader)
